module.exports = __webpack_public_path__ + "static/assets/4b20e6e1976bcc74ca6c2ace671076e1.svg";